export default "__VITE_ASSET__whjP0Q$I__";